const datePickerSingles = document.querySelectorAll('.date-picker-single');

datePickerSingles.forEach((item) => {
  const initElem = item.querySelector('input');

  mobiscroll.datepicker(initElem, {
    controls: ['calendar'],
    theme: 'ios',
    themeVariant: 'light',
    pages: 1,
    min: new Date(),
    locale: localData?.calendar?.locale || mobiscroll.localeEs,
  });
});
